const lbDialog = angular.module('app.lbDialog', []);

lbDialog.controller('lbDialogCont', require('./lbDialogCont'));
lbDialog.directive('lbDialog', require('./lbDialogDir'));
lbDialog.service('lbDialogService', require('./lbDialogService'));

export default lbDialog;



// WEBPACK FOOTER //
// ./src/components/lbDialog/index.js